import { Box, SxProps } from '@mui/material'
import React from 'react'

import { CollapsibleBox } from 'components/scenarios/concurrent/CollapsibleBox'
import { ConcurrentExecution } from 'components/scenarios/concurrent/ConcurrentExecution'
import { type ScenarioForTestSuite } from 'components/test-suites/forms/TestSuiteFormContext'
import theme from 'theme'
import { type ScenarioPreview } from 'types/api/reliability-tests/preview'

export const PromotedScenarioPreview: React.FC<{
  scenario: ScenarioForTestSuite
  scenarioPreview: ScenarioPreview
  sx?: SxProps
}> = ({ scenario, scenarioPreview, sx }) => {
  // copy over the sentinelized graph from the ScenarioPreview onto the original scenario
  const sentinelizedScenario = {
    ...scenario,
    graph: scenarioPreview.graph
  }

  return (
    <Box sx={sx}>
      <CollapsibleBox css={{ marginTop: theme.space[2] }}>
        <ConcurrentExecution
          scenario={sentinelizedScenario}
          scenarioPreview={scenarioPreview}
        />
      </CollapsibleBox>
    </Box>
  )
}
